import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import BasePaginationSearchRequest from '../../../RunPay/Admin/IServices/Models/Common/BasePaginationSearchRequest';
import GetUserTerminalRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/GetUserTerminalRequest';
import GetTerminalForUserAddingRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/GetTerminalForUserAddingRequest';
import SetDeviceVerificationRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/SetDeviceVerificationRequest';
import UserAddTerminalActionRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/UserAddTerminalActionRequest';
import UserAddTerminalsRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/UserAddTerminalsRequest';
import RemoveTerminalActionRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/RemoveTerminalActionRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import UserMobileItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/UserMobileItemResponse';
import UserTerminalItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/UserTerminalItemResponse';
import UserMobileShortItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/UserMobileShortItemResponse';
import SearchUserTerminalItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/SearchUserTerminalItemResponse';
import UserAddTerminalsResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/UserAddTerminalsResponse';

export default class UserMobileService {
	webApiService: WebApiService;
	GetPaginatedUsersListEvent = new Events<WsResponseModel<PaginationResponse<UserMobileItemResponse>>>();
	GetPaginatedUserTerminalsEvent = new Events<WsResponseModel<PaginationResponse<UserTerminalItemResponse>>>();
	RemoveLinkWithDeviceEvent = new Events<WsResponseModel<Boolean>>();
	GetSingleUserEvent = new Events<WsResponseModel<UserMobileShortItemResponse>>();
	GetTerminalsForAddingEvent = new Events<WsResponseModel<Array<SearchUserTerminalItemResponse>>>();
	SetDeviceVerificationEvent = new Events<WsResponseModel<Boolean>>();
	AddTerminalToUserEvent = new Events<WsResponseModel<Boolean>>();
	AddTerminalsToUserEvent = new Events<WsResponseModel<Array<UserAddTerminalsResponse>>>();
	RemoveTerminalFromUserEvent = new Events<WsResponseModel<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('UserMobileService', 'GetPaginatedUsersList', (res: WsResponseModel<PaginationResponse<UserMobileItemResponse>>) => {
			self.GetPaginatedUsersListEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'GetPaginatedUserTerminals', (res: WsResponseModel<PaginationResponse<UserTerminalItemResponse>>) => {
			self.GetPaginatedUserTerminalsEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'RemoveLinkWithDevice', (res: WsResponseModel<Boolean>) => {
			self.RemoveLinkWithDeviceEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'GetSingleUser', (res: WsResponseModel<UserMobileShortItemResponse>) => {
			self.GetSingleUserEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'GetTerminalsForAdding', (res: WsResponseModel<Array<SearchUserTerminalItemResponse>>) => {
			self.GetTerminalsForAddingEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'SetDeviceVerification', (res: WsResponseModel<Boolean>) => {
			self.SetDeviceVerificationEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'AddTerminalToUser', (res: WsResponseModel<Boolean>) => {
			self.AddTerminalToUserEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'AddTerminalsToUser', (res: WsResponseModel<Array<UserAddTerminalsResponse>>) => {
			self.AddTerminalsToUserEvent.trigger(res);
		});
		webApiService.on('UserMobileService', 'RemoveTerminalFromUser', (res: WsResponseModel<Boolean>) => {
			self.RemoveTerminalFromUserEvent.trigger(res);
		});
	}
	GetPaginatedUsersList(request: BasePaginationSearchRequest = null) { 	
        this.webApiService.send('UserMobileService', 'GetPaginatedUsersList' , request);
    }
	GetPaginatedUserTerminals(request: GetUserTerminalRequest = null) { 	
        this.webApiService.send('UserMobileService', 'GetPaginatedUserTerminals' , request);
    }
	RemoveLinkWithDevice(userId: number = 0) { 	
        this.webApiService.send('UserMobileService', 'RemoveLinkWithDevice' , userId);
    }
	GetSingleUser(userId: number = 0) { 	
        this.webApiService.send('UserMobileService', 'GetSingleUser' , userId);
    }
	GetTerminalsForAdding(request: GetTerminalForUserAddingRequest = null) { 	
        this.webApiService.send('UserMobileService', 'GetTerminalsForAdding' , request);
    }
	SetDeviceVerification(request: SetDeviceVerificationRequest = null) { 	
        this.webApiService.send('UserMobileService', 'SetDeviceVerification' , request);
    }
	AddTerminalToUser(request: UserAddTerminalActionRequest = null) { 	
        this.webApiService.send('UserMobileService', 'AddTerminalToUser' , request);
    }
	AddTerminalsToUser(request: UserAddTerminalsRequest = null) { 	
        this.webApiService.send('UserMobileService', 'AddTerminalsToUser' , request);
    }
	RemoveTerminalFromUser(request: RemoveTerminalActionRequest = null) { 	
        this.webApiService.send('UserMobileService', 'RemoveTerminalFromUser' , request);
    }
	 // async methods
	async getPaginatedUsersListAsync(request: BasePaginationSearchRequest = null): Promise<PaginationResponse<UserMobileItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedUsersList.bind(this), this.GetPaginatedUsersListEvent)(request);
	}
	async getPaginatedUserTerminalsAsync(request: GetUserTerminalRequest = null): Promise<PaginationResponse<UserTerminalItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedUserTerminals.bind(this), this.GetPaginatedUserTerminalsEvent)(request);
	}
	async removeLinkWithDeviceAsync(userId: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.RemoveLinkWithDevice.bind(this), this.RemoveLinkWithDeviceEvent)(userId);
	}
	async getSingleUserAsync(userId: number = 0): Promise<UserMobileShortItemResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetSingleUser.bind(this), this.GetSingleUserEvent)(userId);
	}
	async getTerminalsForAddingAsync(request: GetTerminalForUserAddingRequest = null): Promise<Array<SearchUserTerminalItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetTerminalsForAdding.bind(this), this.GetTerminalsForAddingEvent)(request);
	}
	async setDeviceVerificationAsync(request: SetDeviceVerificationRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.SetDeviceVerification.bind(this), this.SetDeviceVerificationEvent)(request);
	}
	async addTerminalToUserAsync(request: UserAddTerminalActionRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.AddTerminalToUser.bind(this), this.AddTerminalToUserEvent)(request);
	}
	async addTerminalsToUserAsync(request: UserAddTerminalsRequest = null): Promise<Array<UserAddTerminalsResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.AddTerminalsToUser.bind(this), this.AddTerminalsToUserEvent)(request);
	}
	async removeTerminalFromUserAsync(request: RemoveTerminalActionRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.RemoveTerminalFromUser.bind(this), this.RemoveTerminalFromUserEvent)(request);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/UserMobileService.ts